export default "__VITE_ASSET__BYnmD1xc__"